/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/motorcycle_medium'
export default icon
